<template>
    <div v-clickaway="collapse" class="sidebar">
        <div class="sidebar-inner">
            <div class="sidebar-logo">
                <router-link :to="{ name: 'home' }" class="sidebar-link td-n">
                    <div class="logo">
                        <img src="@/assets/logo.png" alt="">
                    </div>
                </router-link>
            </div>

            <ul class="sidebar-menu">
                <li class="nav-item" @click="collapse">
                    <router-link :to="{ name: 'home' }" class="sidebar-link">
                        <!-- active -->
                        <span class="icon-holder">
                            <i class="tlm-icon-chart" />
                        </span><span class="title">Главная</span>
                    </router-link>
                </li>

                <template v-if="!companyIsSuspended || isAdmin">
                    <li class="nav-item" @click="collapse">
                        <router-link :to="{ name: 'vms' }" class="sidebar-link">
                            <span class="icon-holder">
                                <i class="tlm-icon-vm" />
                            </span>
                            <span class="title">Торговые автоматы</span>
                        </router-link>
                    </li>

                    <li class="nav-item" @click="collapse">
                        <router-link :to="{ name: 'modems' }" class="sidebar-link">
                            <span class="icon-holder">
                                <i class="tlm-icon-modem" />
                            </span><span class="title">Модемы</span>
                        </router-link>
                    </li>

                    <li class="nav-item" @click="collapse">
                        <router-link :to="{ name: 'stocks' }" class="sidebar-link">
                            <span class="icon-holder">
                                <i class="tlm-icon-food" />
                            </span><span class="title">Каталог продуктов</span>
                        </router-link>
                    </li>
                </template>

                <li class="nav-item d-block d-sm-none" @click="collapse">
                    <router-link :to="{ name: 'profile' }" class="sidebar-link">
                        <span class="icon-holder">
                            <i class="tlm-icon-account" />
                        </span><span class="title">Профиль</span>
                    </router-link>
                </li>

                <li class="nav-item d-block d-sm-none" @click="collapse">
                    <router-link :to="{ name: 'logout' }" class="sidebar-link">
                        <span class="icon-holder">
                            <i class="tlm-icon-redo" />
                        </span><span class="title">Выход</span>
                    </router-link>
                </li>

                <li v-if="isAdmin" class="nav-item" @click="collapse">
                    <router-link :to="{ name: 'admin' }" class="sidebar-link">
                        <span class="icon-holder">
                            <i class="tlm-icon-info-circle" />
                        </span><span class="title">Админка</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isAdmin: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile
        },

        companyIsSuspended() {
            return this.$store.getters['company/suspended']
        }
    },
    methods: {
        collapse() {
            if (this.isMobile) {
                this.$emit('collapse')
            }
        }
    }
}
</script>
